import { FC } from 'react'
import {
  IconZoomOut,
  IconZoomIn,
  IconFocusExposure,
  Button,
  ButtonGroup,
  Flex
} from '@sequencehq/core-components'
import { type ReactFlowState, useReactFlow, useStore } from '@xyflow/react'
import { FIT_VIEW_OPTIONS } from 'Automations/automationEditor/constants'

const zoomSelector = (state: ReactFlowState) => {
  const zoom = state.transform[2]
  const { minZoom, maxZoom } = state
  return { zoom, minZoom, maxZoom }
}

export const ZoomControls: FC = () => {
  const { zoomIn, zoomOut, fitView } = useReactFlow()
  const { zoom, minZoom, maxZoom } = useStore(zoomSelector)

  const zoomControls = [
    {
      testId: 'automations.editor.zoomOut',
      Icon: IconZoomOut,
      label: 'Zoom out',
      onClick: () => zoomOut(),
      disabled: zoom <= minZoom
    },
    {
      testId: 'automations.editor.zoomIn',
      Icon: IconZoomIn,
      label: 'Zoom in',
      onClick: () => zoomIn(),
      disabled: zoom >= maxZoom
    }
  ]

  return (
    <Flex position="absolute" bottom="12px" right="12px" gap="8px">
      {/* Re-centre is a viewport action, distinct from zooming, so it sits on
          its own rather than inside the zoom group. */}
      <Button
        data-testid="automations.editor.recentre"
        variant="secondary"
        size="36px"
        icon={<IconFocusExposure color="inherit" />}
        aria-label="Re-centre"
        onClick={() => fitView({ ...FIT_VIEW_OPTIONS, duration: 300 })}
      />

      <ButtonGroup>
        {zoomControls.map(({ testId, Icon, label, onClick, disabled }) => (
          <Button
            key={testId}
            data-testid={testId}
            variant="secondary"
            size="36px"
            icon={<Icon color="inherit" />}
            aria-label={label}
            onClick={onClick}
            disabled={disabled}
          />
        ))}
      </ButtonGroup>
    </Flex>
  )
}
